import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../api/context';
import toast from '../../utils/toast';
import { Title } from '../../utils/title';
import Layout from './Layout';
import styles from './_03_Profile.module.scss';

const _03_Profile = () => {

  const { token } = useAPIContext();
  const [ loading, setLoading ] = useState(false);

  const navigate = useNavigate();

  const next = () => {
    navigate('/wizard/socials');
  };

  return (
    <>
      <Title value='Profile' />
      <Layout step='profile' auth={true}>
        <div className={styles.root}>

          <Formik
            initialValues={{
              first_name: '',
              last_name: '',
              gender: '',
              instagram: '',
              paypal: '',
            }}
            validationSchema={yup.object({
              first_name: yup.string()
                .required('Required'),
              last_name: yup.string()
                .required('Required'),
              gender: yup.string()
                .required('Required'),
              instagram: null,
              paypal: null,
            })}
            onSubmit={(values, actions) => {

              if (loading) {
                return;
              }

              setLoading(true);

              api(token).v1.profile
                .update({
                  first_name: values.first_name,
                  last_name: values.last_name,
                  gender: values.gender,

                  instagram: values.instagram || undefined,
                  paypal: values.paypal || undefined,
                })
                .then(res => {
                  setLoading(false);

                  if (res.status === 200) {
                    next();
                  }

                  if (res.status === 400) {
                    toast.show(toast.KIND.ERROR, res.body);
                  }
                })
                .catch(err => {
                  setLoading(false);
                  toast.show(toast.KIND.WARNING, err);
                });

            }} >

            <Form>
              <div>
                <label htmlFor='first_name'>First Name</label>
                <Field
                  id='first_name'
                  aria-label='first name'
                  name='first_name'
                  type='text'
                  disabled={loading}
                />
                <ErrorMessage
                  name='first_name'
                  component='div'
                />
              </div>

              <div>
                <label htmlFor='last_name'>Last Name</label>
                <Field
                  id='last_name'
                  aria-label='last name'
                  name='last_name'
                  type='text'
                  disabled={loading}
                />
                <ErrorMessage
                  name='last_name'
                  component='div'
                />
              </div>

              <div>
                <label htmlFor='gender'>Gender</label>
                <Field
                  id='gender'
                  as='select'
                  aria-label='gender'
                  name='gender'
                  disabled={loading} >

                  <option value='U'></option>
                  <option value='M'>Male</option>
                  <option value='F'>Female</option>
                  <option value='O'>Other</option>
                </Field>
                <ErrorMessage
                  name='gender'
                  component='div'
                />
              </div>

              <div>
                <label htmlFor='instagram'>Instagram</label>
                <Field
                  id='instagram'
                  aria-label='instagram'
                  name='instagram'
                  type='text'
                  disabled={loading}
                />
                <ErrorMessage
                  name='instagram'
                  component='div'
                />
              </div>

              <div>
                <label htmlFor='instagram'>PayPal</label>
                <Field
                  id='paypal'
                  aria-label='paypal'
                  name='paypal'
                  type='text'
                  disabled={loading}
                />
                <ErrorMessage
                  name='paypal'
                  component='div'
                />
              </div>

              <button
                type='submit'
                disabled={loading}>

                Confirm

              </button>
            </Form>

          </Formik>

        </div>
      </Layout>
    </>
  );
};

export default _03_Profile;